import { useState, useEffect } from 'react'
import { getPositionExpandAPI } from '../../services/position'

function UsePositionsExpand(orgId, divisionId, departmentId, teamId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = {
      orgId,
      dsId: divisionId,
      dmId: departmentId,
      teamId,
      searchs
    }
    const getData = async () => {
      const result = await getPositionExpandAPI(param)
      if (!result) return

      const newData = result.result.map((d, i) => {
        return {
          value: d?.position_id ?? '',
          label: d?.position,
         data: d?.position
        }
      })

      setData(newData)
    }
    if (orgId > 0 && teamId > 0) {
      getData()
    }
  }, [orgId, teamId, searchs])

  return data
}

export default UsePositionsExpand
